/**
 * store/modules/transaction.js
 *
 * Vuex module handling transaction state and actions.
 */
import axios from 'axios'

export default {
  // Transaction state.
  state: {
    transactions: [],
    transaction: {}
  },

  // Mutations to alter transaction state.
  mutations: {
    setTransactions: (state, transactions) => (state.transactions = transactions),
    setTransaction: (state, transaction) => (state.transaction = transaction)
  },

  // Actions handling requests, and committing mutations.
  actions: {
    // POST Transaction search.
    async getTransactions ({ commit }, req = {}) {
      try {
        let response = await axios.put('/api/transaction/search', req)
        commit('setTransactions', response.data)
      } catch (error) {
        console.error('Unable to fetch transactions.')
        console.error(error)
      }
    },

    /**
     * POST Fund In
     *
     *  payload {
     *    amount: (number, optional),
     *    notes: (string, optional),
     *    userIntegrationId: (integer, optional)
     *  } 
     */
    async fundIn ({ commit }, payload) {
      try {
        let response = await axios.post('/api/transaction/fund-in', payload)
        commit('setTransaction', response.data)
      } catch (error) {
        console.error('Unable to post funding.')
        console.error(error)
      }
    },

    /**
     * POST Fund Out
     *
     *  payload {
     *    amount: (number, optional),
     *    method: (string),
     *    accountIdentifier: (string),
     *    notes: (string, optional),
     *    userIntegrationId: (integer, optional)
     *  } 
     */
    async fundOut ({ commit }, payload) {
      try {
        let response = await axios.post('/api/transaction/fund-out', payload)
        commit('setTransaction', response.data)
      } catch (error) {
        console.error('Unable to post withdrawal request.')
        console.error(error)
      }
    }
  },

  // Transaction state getters.
  getters: {
    transactions: state => state.transactions,
    transaction: state => state.transaction
  }
}
